<template>
  <div id="app" class="movies" data-page="movies">
    <div class="movies-wrap">
      <div class="movies-title">影片</div>
      <div class="movies-box">
        <div class="movies-box-inner">
          <ul class="movies-list">
            <li class="movies-list__li movies-list__li--skt show">
              <a
                href="javascript:;"
                class="movies-list__img-box movies-list__img-box--skt"
              ></a>
              <p></p>
            </li>
          </ul>
          <div class="movies-slider-wrap">
            <div class="movies-slider-box movies-slider-box--skt">
              <a href="javascript:;" class="movies-slider">
                <div class="movies-slider-img movies-slider-img--skt">
                  <span></span>
                </div>
              </a>
            </div>
            <a href="javascript:;" class="movies-slider-prev"></a>
            <a href="javascript:;" class="movies-slider-next"></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { articlenNews } from "@api/index";
import { VUE_APP_API_URL } from "@utils/index";

export default {
  name: "Movie",
  components: {},
  data() {
    return {
      downloadList: [],
      baseUrl: VUE_APP_API_URL
    };
  },
  mounted: function() {
    window.$("#LT_age").remove();
    let that = this;
    that.initData();
  },
  methods: {
    initData() {
      console.log("Update In 2021/10/11 12:20");
      let that = this;
      articlenNews({
        class_id: 13,
        page: 0
      }).then(res => {
        var topHTML = "";
        var navHTML = "";
        var movieList = res.new_list.map(e => {
          return {
            imageUrl: e.video_img,
            seq: e.content_id,
            title: e.title,
            videoUrl: e.image
          };
        });
        movieList.forEach(function(v) {
          topHTML += that.movieTopRender(v);
          navHTML += that.movieNavHTMLRender(v);
        });
        that.$(".movies-list").html(topHTML);
        that.$(".movies-slider-box").html(navHTML);
        that
          .$(".movies-list__li")
          .eq(0)
          .addClass("show");

        that.tns({
          container: ".movies-slider-box",
          items: 2,
          loop: false,
          swipeAngle: false,
          speed: 400,
          autoplayButtonOutput: false,
          prevButton: ".movies-slider-prev", // 自定義的 上一頁
          nextButton: ".movies-slider-next", // 自定義的 下一頁
          nav: false,
          mouseDrag: true,
          responsive: {
            768: {
              items: 4
            }
          }
        });
      });
    },
    movieNavHTMLRender(data) {
      var movieNavHTML =
        '<a href="javascript:;" class="movies-slider" data-video="' +
        data.videoUrl +
        '" data-seq="' +
        data.seq +
        '">\
                <div class="movies-slider-img">\
                    <img src="' +
        this.baseUrl +
        data.imageUrl +
        '" alt="">\
                 </div>\
            </a>';
      return movieNavHTML;
    },
    movieTopRender(data) {
      var movieTopHTML =
        '<li class="movies-list__li">\
                <a href = "javascript:;" class="movies-list__img-box"  data-video="' +
        `${
          data.videoUrl.includes("http")
            ? data.videoUrl
            : this.baseUrl + data.videoUrl
        }` +
        '" data-seq="' +
        data.seq +
        '">\
                    <img src="' +
        this.baseUrl +
        data.imageUrl +
        '" alt="">\
                </a>\
                <p>' +
        data.title +
        "</p>\
            </li >";
      return movieTopHTML;
    }
  }
};
</script>
<style scoped></style>
